module.exports = __webpack_public_path__ + "static/media/29FUNOV9.2303ca4a.jpg";